const textFieldForgotPasswordConfirm = {
  email: 'Your email',
  password: 'Password',
  helperText: 'Minimum of 6 characters',
  confirmPassword: 'Confirm your password',
  passwordError: 'Different passwords'
};

export default textFieldForgotPasswordConfirm;
